export const positions = {
  candidate: 'candidate',
  member: 'member',
  officer: 'officer',
  admin: 'admin',
};
